import React, { useEffect, useState } from 'react';
import classes from './Blog.module.css';
import Typical from 'react-typical';
import Navigation from '../../Components/Navigation/Navigation'
import Footer from '../../Components/Footer/Footer'
import searchicon from '../../Assets/search.png';
import arrowup from '../../Assets/arrow-up-right.png';
import arrowleft from '../../Assets/arrow-left.png';
import arrowright from '../../Assets/arrow-right.png';
import { Link, useLocation } from 'react-router-dom';

const Blog = () => {

  const [fadeIn, setFadeIn] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    setTimeout(() => setFadeIn(true), 2000); // Trigger fade-in after 2 seconds
  }, []);

const location = useLocation();

useEffect(() => {
    window.scrollTo(0, 0);
}, [location]);

  return (
  <>
  <Navigation />
    <div className={classes.landingPage}>
      
      <div className={classes.blogContent}>
        <h1 className={classes.htag}><Typical
          steps={['ScaleWorkFlow Blog', 2000]} // Typing effect
          loop={1}
          wrapper="span"
        /></h1>
        <p className={`${classes.peetag} ${fadeIn ? classes.fadeIn : ''}`}>View our works reflecting the unique solutions we have provided for our clients diverse needs</p>
      </div>

      <div className={classes.blogContainer}>
        <div className={classes.searchContainer}>
          <img src={searchicon} alt="search" className={classes.searchIcon} />
          <input type="text" placeholder="Search" className={classes.searchBar} />
        </div>

        <select className={classes.select}>
          <option value="latest">Newest First</option>
          <option value="oldest">Oldest</option>
        </select >
      </div>
      <div className={classes.blogPostContainerentire}>
        <Link to={'/blog_details'} > <div className={classes.blogPostContainerall}>
          <div className={classes.blogPostContainer}>
            <div className={`${classes.blogPost} ${classes.blogPosttouched}`}>
              <div className={classes.blogPost1}>
                <p className={classes.blogger}>Olivia Rhye</p>
                <p className={classes.bloggerdte}>20 Jan 2022</p>
              </div>
              <p className={classes.bloggertitle}>Design</p>
            </div>
          </div>

          <div className={classes.blogPostContainer2}>
            <div className={classes.blogPosttxt}>
              <p className={classes.uxrvw}>UX review presentations</p>
              <p className={classes.rvwbdy}>How do you create compelling presentations that wow your colleagues and impress your managers?</p>
              <Link to={'/blog_details'} > <div className={classes.readPost}>
                <p className={classes.rdpst} style={{marginTop: '12px' }}>Read post</p>
                <img src={arrowup} className={classes.arrow} alt="arrow" />
              </div>
              </Link>
            </div>
          </div>
        </div>
        </Link>
        <Link to={'/blog_details'} > <div className={classes.blogPostContainerall}>
          <div className={classes.blogPostContainer22}>
            <div className={classes.blogPost}>
              <div className={classes.blogPost1}>
                <p className={classes.blogger}>Phoenix Baker</p>
                <p className={classes.bloggerdte}>19 Jan 2022</p>
              </div>
              <p className={classes.bloggertitle}>Design</p>
            </div>
          </div>

          <div className={classes.blogPostContainer2}>
            <div className={classes.blogPosttxt}>
              <p className={classes.uxrvw}>Migrating to Linear 101</p>
              <p className={classes.rvwbdy}>Linear helps streamline software projects, sprints, tasks, and bug tracking. Here’s how to get started.</p>
              <Link to={'/blog_details'} > <div className={classes.readPost}>
                <p className={classes.rdpst} style={{marginTop: '12px' }}>Read post</p>
                <img src={arrowup} className={classes.arrow} alt="arrow" />
              </div>
              </Link>
            </div>
          </div>
        </div>
        </Link>
      </div>
      <div className={classes.blogPostContainerentire}>
         <Link to={'/blog_details'} ><div className={classes.blogPostContainerall}>
          <div className={classes.blogPostContainer12}>
            <div className={classes.blogPost}>
              <div className={classes.blogPost1}>
                <p className={classes.blogger}>Lana Steiner</p>
                <p className={classes.bloggerdte}>18 Jan 2022</p>
              </div>
              <p className={classes.bloggertitle}>Design</p>
            </div>
          </div>

          <div className={classes.blogPostContainer2}>
            <div className={classes.blogPosttxt}>
              <p className={classes.uxrvw}>Building your API Stack</p>
              <p className={classes.rvwbdy}>The rise of RESTful APIs has been met by a rise in tools for creating, testing, and managing them.</p>
              <Link to={'/blog_details'} > <div className={classes.readPost}>
                <p className={classes.rdpst} style={{marginTop: '12px' }}>Read post</p>
                <img src={arrowup} className={classes.arrow} alt="arrow" />
              </div>
              </Link>
            </div>
          </div>
        </div></Link>
        <Link to={'/blog_details'} > <div className={classes.blogPostContainerall}>
          <div className={classes.blogPostContainer23}>
            <div className={classes.blogPost}>
              <div className={classes.blogPost1}>
                <p className={classes.blogger}>Alec Whitten</p>
                <p className={classes.bloggerdte}>17 Jan 2022</p>
              </div>
              <p className={classes.bloggertitle}>Design</p>
            </div>
          </div>

          <div className={classes.blogPostContainer2}>
            <div className={classes.blogPosttxt}>
              <p className={classes.uxrvw}>Bill Walsh leadership lessons</p>
              <p className={classes.rvwbdy}>Like to know the secrets of transforming a 2-14 team into a 3x Super Bowl winning Dynasty?</p>
              <Link to={'/blog_details'} ><div className={classes.readPost}>
                <p className={classes.rdpst} style={{marginTop: '12px' }}>Read post</p>
                <img src={arrowup} className={classes.arrow} alt="arrow" />
              </div>
              </Link>
            </div>
          </div>
        </div></Link>
      </div>
      <div className={classes.blogPostContainerentire}>
         <Link to={'/blog_details'} ><div className={classes.blogPostContainerall}>
          <div className={classes.blogPostContainer}>
            <div className={`${classes.blogPost} ${classes.blogPosttouched}`}>
              <div className={classes.blogPost1}>
                <p className={classes.blogger}>Olivia Rhye</p>
                <p className={classes.bloggerdte}>20 Jan 2022</p>
              </div>
              <p className={classes.bloggertitle}>Design</p>
            </div>
          </div>

          <div className={classes.blogPostContainer2}>
            <div className={classes.blogPosttxt}>
              <p className={classes.uxrvw}>UX review presentations</p>
              <p className={classes.rvwbdy}>How do you create compelling presentations that wow your colleagues and impress your managers?</p>
              <Link to={'/blog_details'} > <div className={classes.readPost}>
                <p className={classes.rdpst} style={{marginTop: '12px' }} >Read post</p>
                <img src={arrowup} className={classes.arrow} alt="arrow" />
              </div>
              </Link>
            </div>
          </div>
        </div></Link>
         <Link to={'/blog_details'} ><div className={classes.blogPostContainerall}>
          <div className={classes.blogPostContainer22}>
            <div className={classes.blogPost}  >
              <div className={classes.blogPost1}>
                <p className={classes.blogger}>Phoenix Baker</p>
                <p className={classes.bloggerdte}>19 Jan 2022</p>
              </div>
              <p className={classes.bloggertitle}>Design</p>
            </div>
          </div>

          <div className={classes.blogPostContainer2}>
            <div className={classes.blogPosttxt}>
              <p className={classes.uxrvw}>Migrating to Linear 101</p>
              <p className={classes.rvwbdy}>Linear helps streamline software projects, sprints, tasks, and bug tracking. Here’s how to get started.</p>
              <Link to={'/blog_details'} ><div className={classes.readPost}>
                <p className={classes.rdpst} style={{marginTop: '12px' }}>Read post</p>
                <img src={arrowup} className={classes.arrow} alt="arrow" />
              </div>
              </Link>
            </div>
          </div>
        </div></Link>
      </div>
      <div className={classes.blogPostContainerentire}>
         <Link to={'/blog_details'} ><div className={classes.blogPostContainerall}>
          <div className={classes.blogPostContainer12}>
            <div className={classes.blogPost}>
              <div className={classes.blogPost1}>
                <p className={classes.blogger}>Lana Steiner</p>
                <p className={classes.bloggerdte}>18 Jan 2022</p>
              </div>
              <p className={classes.bloggertitle}>Design</p>
            </div>
          </div>

          <div className={classes.blogPostContainer2}>
            <div className={classes.blogPosttxt}>
              <p className={classes.uxrvw}>Building your API Stack</p>
              <p className={classes.rvwbdy}>The rise of RESTful APIs has been met by a rise in tools for creating, testing, and managing them.</p>
              <Link to={'/blog_details'} > <div className={classes.readPost}>
                <p className={classes.rdpst} style={{marginTop: '12px' }}>Read post</p>
                <img src={arrowup} className={classes.arrow} alt="arrow" />
              </div>
              </Link>
            </div>
          </div>
        </div></Link>
        <Link to={'/blog_details'} > <div className={classes.blogPostContainerall}>
          <div className={classes.blogPostContainer23}>
            <div className={classes.blogPost}>
              <div className={classes.blogPost1}>
                <p className={classes.blogger}>Alec Whitten</p>
                <p className={classes.bloggerdte}>17 Jan 2022</p>
              </div>
              <p className={classes.bloggertitle}>Design</p>
            </div>
          </div>

          <div className={classes.blogPostContainer2}>
            <div className={classes.blogPosttxt}>
              <p className={classes.uxrvw}>Bill Walsh leadership lessons</p>
              <p className={classes.rvwbdy}>Like to know the secrets of transforming a 2-14 team into a 3x Super Bowl winning Dynasty?</p>
              <Link to={'/blog_details'} ><div className={classes.readPost}>
                <p className={classes.rdpst} style={{marginTop: '12px' }}>Read post</p>
                <img src={arrowup} className={classes.arrow} alt="arrow" />
              </div>
              </Link>
            </div>
          </div>
        </div></Link>
      </div>

      <div className={classes.paginationContainer}>
        <button className={classes.paginationbtn}> <img src={arrowleft} className={classes.arrowpagination} /> <span>Previous</span></button>
        <div className={classes.pagination}>
          <p className={classes.pfrst}>1</p>
          <p className={classes.pfrst2}>2</p>
          <p className={classes.pfrst2}>3</p>
          <p className={classes.pfrst2}>...</p>
          <p className={classes.pfrst2}>8</p>
          <p className={classes.pfrst2}>9</p>
          <p className={classes.pfrst2}>10</p>
        </div>
        <div className={classes.paginationmble}>
          <p className={classes.pfrst2}>Page 1 of 10</p>
        </div>
        <button className={classes.paginationbtn}><span>Next</span><img src={arrowright} className={classes.arrowpagination} /> </button>
      </div>
    </div>
    <Footer />
    </>
  );
}

export default Blog;
